<template>
	<div>
		<div class="header-item">
			<h1>Metadata</h1>
		</div>

		<div class="white">
			<div class="row">
				<div class="col-20">
					<div class="toolbar">
						<nav class="subnav">
							<ul>
								<li>
									<LangSwitch type="single" v-bind:downloadCallback="getMarketsCompleteHandler" v-bind:callback="langChanged"></LangSwitch>
								</li>
								<!-- <li><a href="#">Code</a></li> -->
							</ul>
						</nav>
					</div>
				</div>
			</div>
		</div>

		<table cellpadding="0" cellspacing="0" class="data  transition-fadeinup" v-for="(struct, name) in list" v-bind:key="name">
			<thead>
<!--
			<tr>
				<th></th>
				<th colspan="4"><br><h3>{{name}}</h3></th>
			</tr>
-->
			<tr>
				<th></th>
				<th>Page</th>
				<th>Metadata</th>
				<th></th>
				<th></th>
			</tr>
			</thead>

			<tbody>
				<template v-for="item in struct">
					<tr v-if="item.mrkt_id == activeLanguage.id" v-bind:key="item.meta.id">
						<td>
						</td>
						<td>
							<!-- <a class="btn-toggle-child"><i class="fa fa-plus"></i></a> -->
							<span v-html="item.page_title"></span>
							<a :href="item.page_url" target="livePreview" class="btn-cms-open path">{{item.page_url}}</a>
						</td>
						<td>
							<div class="metadata">
								<div class="img" v-bind:style="{ backgroundImage: 'url(' + item.meta.image.value + ')' }"></div>
								<div class="title">{{item.meta.title.value}}</div>
								<div class="text">{{item.meta.descr.value}}</div>
							</div>
						</td>
						<td class="btns">
							<router-link :to="`${item.edit_url}`"><i class="fa fa-pen"></i></router-link>
						</td>
						<td></td>
					</tr>
				</template>
<!--
				<tr>
					<td>
					</td>
					<td>
						<a class="btn-toggle-child"><i class="fa fa-plus"></i></a> Homepage
						<a href="http://www.tandarts-meldert.be" target="livePreview" class="btn-cms-open path">/nl/homepage</a>
					</td>
					<td>
						<div class="metadata">
							<div class="img" style="background-image: url(/assets/photos/home-visual-1.png)"></div>
							<div class="title">Jouw carrière bij La Lorraine Bakery Group</div>
							<div class="text">Vind een job bij La Lorraine Bakery Group, de grootste bakkerij van het land. Ontdek wat schuil gaat achter ons brood en onze patisserie.verder vorm te geven. Werkzekerheid gegarandeerd.</div>
						</div>
					</td>
					<td class="btns">
						<a href="#"><i class="fa fa-pen"></i></a>
					</td>
					<td></td>
				</tr>

				<tr class="child level1">
					<td>
					</td>
					<td>
						<a class="btn-toggle-child"><i class="fa fa-plus"></i></a> Homepage
						<a href="http://www.tandarts-meldert.be" target="livePreview" class="btn-cms-open path">/nl/homepage</a>
					</td>
					<td>
						<div class="metadata">
							<div class="img" style="background-image: url(/assets/photos/home-visual-1.png)"></div>
							<div class="title">Vind een job bij La Lorraine Bakery Group</div>
							<div class="text inherit">De grootste bakkerij van het land. Ontdek wat schuil gaat achter ons brood en onze patisserie.verder vorm te geven. Werkzekerheid gegarandeerd.</div>
						</div>
					</td>
					<td class="btns">
						<a href="#"><i class="fa fa-pen"></i></a>
					</td>
					<td></td>
				</tr>

				<tr class="child level2">
					<td>
					</td>
					<td>
						Meldert
						<a href="http://www.tandarts-meldert.be" target="livePreview" class="btn-cms-open path">/nl/homepage</a>
					</td>
					<td>
						<div class="metadata">
							<div class="img inherit" style="background-image: url(/assets/photos/home-visual-1.png)"></div>
							<div class="title inherit">Carrière bij La Lorraine Bakery Group</div>
							<div class="text inherit">De grootste bakkerij van het land. Ontdek wat schuil gaat achter ons brood en onze patisserie.verder vorm te geven. Werkzekerheid gegarandeerd.</div>
						</div>
					</td>
					<td class="btns">
						<a href="#"><i class="fa fa-pen"></i></a>
					</td>
					<td></td>
				</tr>

				<tr>
					<td>
					</td>
					<td>
						<a class="btn-toggle-child"><i class="fa fa-plus"></i></a> Homepage
						<a href="http://www.tandarts-meldert.be" target="livePreview" class="btn-cms-open path">/nl/homepage</a>
					</td>
					<td>
						<div class="metadata">
							<div class="img" style="background-image: url(/assets/photos/home-visual-1.png)"></div>
							<div class="title">Jouw carrière bij La Lorraine Bakery Group</div>
							<div class="text">Vind een job bij La Lorraine Bakery Group, de grootste bakkerij van het land. Ontdek wat schuil gaat achter ons brood en onze patisserie.verder vorm te geven. Werkzekerheid gegarandeerd.</div>
						</div>
					</td>
					<td class="btns">
						<a href="#"><i class="fa fa-pen"></i></a>
					</td>
					<td></td>
				</tr>

				<tr class="child level1">
					<td>
					</td>
					<td>
						<a class="btn-toggle-child"><i class="fa fa-plus"></i></a> Homepage
						<a href="http://www.tandarts-meldert.be" target="livePreview" class="btn-cms-open path">/nl/homepage</a>
					</td>
					<td>
						<div class="metadata">
							<div class="img" style="background-image: url(/assets/photos/home-visual-1.png)"></div>
							<div class="title">Vind een job bij La Lorraine Bakery Group</div>
							<div class="text inherit">De grootste bakkerij van het land. Ontdek wat schuil gaat achter ons brood en onze patisserie.verder vorm te geven. Werkzekerheid gegarandeerd.</div>
						</div>
					</td>
					<td class="btns">
						<a href="#"><i class="fa fa-pen"></i></a>
					</td>
					<td></td>
				</tr>

				<tr class="child level2">
					<td>
					</td>
					<td>
						Meldert
						<a href="http://www.tandarts-meldert.be" target="livePreview" class="btn-cms-open path">/nl/homepage</a>
					</td>
					<td>
						<div class="metadata">
							<div class="img inherit" style="background-image: url(/assets/photos/home-visual-1.png)"></div>
							<div class="title inherit">Carrière bij La Lorraine Bakery Group</div>
							<div class="text inherit">De grootste bakkerij van het land. Ontdek wat schuil gaat achter ons brood en onze patisserie.verder vorm te geven. Werkzekerheid gegarandeerd.</div>
						</div>
					</td>
					<td class="btns">
						<a href="#"><i class="fa fa-pen"></i></a>
					</td>
					<td></td>
				</tr>

				<tr>
					<td>
					</td>
					<td>
						<a class="btn-toggle-child"><i class="fa fa-plus"></i></a> Homepage
						<a href="http://www.tandarts-meldert.be" target="livePreview" class="btn-cms-open path">/nl/homepage</a>
					</td>
					<td>
						<div class="metadata">
							<div class="img" style="background-image: url(/assets/photos/home-visual-1.png)"></div>
							<div class="title">Jouw carrière bij La Lorraine Bakery Group</div>
							<div class="text">Vind een job bij La Lorraine Bakery Group, de grootste bakkerij van het land. Ontdek wat schuil gaat achter ons brood en onze patisserie.verder vorm te geven. Werkzekerheid gegarandeerd.</div>
						</div>
					</td>
					<td class="btns">
						<a href="#"><i class="fa fa-pen"></i></a>
					</td>
					<td></td>
				</tr>

				<tr class="child level1">
					<td>
					</td>
					<td>
						<a class="btn-toggle-child"><i class="fa fa-plus"></i></a> Homepage
						<a href="http://www.tandarts-meldert.be" target="livePreview" class="btn-cms-open path">/nl/homepage</a>
					</td>
					<td>
						<div class="metadata">
							<div class="img" style="background-image: url(/assets/photos/home-visual-1.png)"></div>
							<div class="title">Vind een job bij La Lorraine Bakery Group</div>
							<div class="text inherit">De grootste bakkerij van het land. Ontdek wat schuil gaat achter ons brood en onze patisserie.verder vorm te geven. Werkzekerheid gegarandeerd.</div>
						</div>
					</td>
					<td class="btns">
						<a href="#"><i class="fa fa-pen"></i></a>
					</td>
					<td></td>
				</tr>

				<tr class="child level2">
					<td>
					</td>
					<td>
						Meldert
						<a href="http://www.tandarts-meldert.be" target="livePreview" class="btn-cms-open path">/nl/homepage</a>
					</td>
					<td>
						<div class="metadata">
							<div class="img inherit" style="background-image: url(/assets/photos/home-visual-1.png)"></div>
							<div class="title inherit">Carrière bij La Lorraine Bakery Group</div>
							<div class="text inherit">De grootste bakkerij van het land. Ontdek wat schuil gaat achter ons brood en onze patisserie.verder vorm te geven. Werkzekerheid gegarandeerd.</div>
						</div>
					</td>
					<td class="btns">
						<a href="#"><i class="fa fa-pen"></i></a>
					</td>
					<td></td>
				</tr>
-->
			</tbody>
		</table>

	</div>

</template>

<script>

import LangSwitch from '../../components/LangSwitch.vue'
import xhrModule from '../../modules/xhrModule.js'

export default {
	name: 'metadata',
	data () {
		return {
			activeLanguage: null,
			markets: null,
			list: []
		}
	},
	components: {
		'LangSwitch': LangSwitch
	},
	created () {
		this.mainContainer = document.querySelector('#main')
		this.mainContainer.classList.add('loading')
		this.fetchData()
	},
	methods: {
		langChanged (lang) {
			this.activeLanguage = lang
			this.fetchData()
		},
		fetchData () {
			xhrModule.get('/cms/api/metadata/list', this.fetchDataComplete.bind(this))
		},
		fetchDataComplete (data) {
			this.list = Object.keys(data.data).reduce((a, lst) => {
				if (lst !== 'none' && lst !== 'trees') {
					a[lst] = Object.keys(data.data[lst]).reduce((b, lng) => {
						if (lng === this.activeLanguage.locale) {
							Object.keys(data.data[lst][lng]).reduce((c, id) => {
								var n = data.data[lst][lng][id]
								if (n.hasOwnProperty('inst_entt') && n.hasOwnProperty('inst_uuid')) {
									data.data[lst][lng][id].edit_url = '/content/' + n.inst_entt + '/edit/' + n.inst_uuid + '/metadata'
								} else {
									data.data[lst][lng][id].edit_url = '/content/' + n.page_entt_id + '/edit/' + n.page_uuid + '/metadata'
								}
							}, 0)
							return data.data[lst][lng]
						}
						return b
					}, [])
				}
				return a
			}, {})
			this.mainContainer.classList.remove('loading')
		},
		getMarketsCompleteHandler (markets) {
			this.markets = markets.data
		}
	}
}

</script>
